import validator from "validator";

export const validatePassword = (password: string): boolean => {
  const lengthValid = password.length >= 8 && password.length <= 15;
  const includesUpperCase = validator.matches(password, /[A-Z]/);
  const includesLowerCase = validator.matches(password, /[a-z]/);
  const includesNumber = validator.matches(password, /[0-9]/);
  const includesSpecialChar = validator.matches(
    password,
    /[!\"$%&`()+\-./:;<=>?@#$begin:math:display$$end:math:display$\\^_'{}~|]/
  );

  const noSequentialChars = !/(.)\1{3,}/.test(password);
  const noSequentialNumbersOrLetters =
    !/(0123|1234|2345|3456|4567|5678|6789|7890|abcd|bcde|cdef|defg|efgh|fghi|ghij|hijk|ijkl|jklm|klmn|lmno|mnop|nopq|pqrs|qrst|rstu|stuv|uvwx|vwxy|wxyz)/.test(
      password.toLowerCase()
    );

  const combinationValid =
    [
      includesUpperCase,
      includesLowerCase,
      includesNumber,
      includesSpecialChar,
    ].filter(Boolean).length >= 2;

  return (
    lengthValid &&
    combinationValid &&
    noSequentialChars &&
    noSequentialNumbersOrLetters
  );
};
